import { CheckCircleIcon, NotAllowedIcon } from '@chakra-ui/icons';
import { Flex, Spinner } from '@chakra-ui/react';
import { AntiVirusStatuses, DecryptionStatuses } from 'common';
import React from 'react';

interface IconActionProps {
    isLoading: boolean;
    antiVirusStatus?: string;
    decryptionStatus?: string;  // Enum value (NOT_APPLICABLE when not encrypted)
    type?: 'antiVirus' | 'decryption';
}

const LoadingIcon = () => (
    <Flex align="center" gap={3}>
        <Spinner data-testid="spinner" size="xs" color="blue.500" />
    </Flex>
)

const InfectedIcon = () => <NotAllowedIcon color="red.500" />

const SuccessIcon = () => <CheckCircleIcon color="green.500" />

const IconAction = ({ 
    isLoading, 
    antiVirusStatus, 
    decryptionStatus,
    type = 'antiVirus'
}: IconActionProps) => {
    const status = type === 'antiVirus' ? antiVirusStatus : decryptionStatus;
    
    if (isLoading) return <LoadingIcon />
    
    // Error states - show error icon
    if (
        status === AntiVirusStatuses.INFECTED ||
        status === DecryptionStatuses.FAILED
    ) {
        return <InfectedIcon />
    }
    
    // In-progress states - show spinner
    if (
        status === AntiVirusStatuses.SCANNING ||
        status === DecryptionStatuses.REQUESTED ||
        status === DecryptionStatuses.IN_PROGRESS
    ) {
        return <LoadingIcon />
    }
    
    // Success states - show success icon
    return <SuccessIcon />
}

export default IconAction;